module.exports = __webpack_public_path__ + "img/xun_icon2.3dd13280.png";